import React from "react";

import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  title: string;
  percentage: number;
  grams: string;
}

const useStyles = makeStyles()({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  percentage: {
    fontWeight: 700,
    color: "#2D87BB",
  },
  gramText: {
    fontSize: 28,
    fontWeight: 700,
  },
  calLabel: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.gray,
  },
});

const GramsProgressItem: React.FC<Props> = ({ title, percentage, grams }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <Typography className={classes.percentage} variant="body1">
        {percentage}%
      </Typography>
      <Typography className={classes.gramText} variant="body1">
        {grams}g
      </Typography>
      <Typography className={classes.calLabel} variant="body1">
        {title}
      </Typography>
    </div>
  );
};

export default GramsProgressItem;
